var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-link btn-l",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$router.go(-1)
                    }
                  }
                },
                [_vm._v("\n          ←\n        ")]
              )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "col-sm",
              domProps: { innerHTML: _vm._s(_vm.data.misc.stepXOfY) }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" }),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-4 card" },
              [
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", {
                  staticClass: "text-primary",
                  domProps: {
                    innerHTML: _vm._s(_vm.data.phoneNumber.phoneNumberHeader)
                  }
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.data.phoneNumber.phoneNumberText)
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "phone-number-wrapper" },
                  [
                    _vm.codesList
                      ? _c(
                          "v-select",
                          {
                            ref: "codes",
                            staticClass: "fs-60",
                            attrs: {
                              placeholder: _vm.data.misc.prefix,
                              reduce: function(country) {
                                return country.code
                              },
                              label: "country",
                              options: _vm.codesList
                            },
                            on: {
                              input: function($event) {
                                return _vm.focusOrBlurInput($event)
                              }
                            },
                            model: {
                              value: _vm.prefix,
                              callback: function($$v) {
                                _vm.prefix = $$v
                              },
                              expression: "prefix"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                attrs: { slot: "no-options" },
                                slot: "no-options"
                              },
                              [_vm._v(_vm._s(_vm.data.misc.noMatchingOptions))]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group sm-3" }, [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v(_vm._s("+" + _vm.prefix || "+"))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.phoneNumber,
                            expression: "phoneNumber"
                          }
                        ],
                        ref: "phone",
                        staticClass: "form-control phone-number-input",
                        attrs: {
                          inputmode: "numeric",
                          type: "text",
                          name: "phoneNumber",
                          maxlength: _vm.phoneLength
                        },
                        domProps: { value: _vm.phoneNumber },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.phoneNumber = $event.target.value
                            },
                            function($event) {
                              return _vm.enforceNumbers()
                            }
                          ]
                        }
                      })
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.data.phoneNumber.phoneNumberExplanation
                    )
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix--min" }),
                _vm._v(" "),
                _c("button", {
                  staticClass: "btn btn-primary btn-lg btn-block",
                  attrs: { disabled: !_vm.isPhoneNumberValid },
                  domProps: { innerHTML: _vm._s(_vm.data.misc.nextBtn) },
                  on: {
                    click: function($event) {
                      return _vm.phoneEntered()
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix--min" }),
                _vm._v(" "),
                _c("alert", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.alert,
                      expression: "alert"
                    }
                  ],
                  domProps: { innerHTML: _vm._s(_vm.data.error.errorHeader) }
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.data.phoneNumber.phoneNumberDisclaimer
                    )
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm" })
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-408b65a9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-408b65a9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmNumber.vue
// module id = null
// module chunks = 